<template>
  <div class="token">
  </div>
</template>

<script>
  export default {
    name: 'Token',
    mounted() {
      // eslint-disable-next-line
      this.$store.dispatch('handleConsoleAuthentication', [this.$route.query.token]);
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Auth/Token.vue